<template>
      <div class="container" id="app">
        <div class="row justify-content-center">
            <div class="col-12 col-md-6">
                <div class="my-5">
                    <Title title="Vue Todo App">  </Title>
    
                    <Form @create ="create"></Form>
                    <div class="d-flex justify-content-between">
                        <h5 class="mb-0 font-weight-bold ">Job Lists</h5>
                        
                        <p class="btn btn-warning">
                            Done {{DoneTotal}}
                        </p>
                    </div>
    
                    <ul class="list-group">
                        <li v-if="lists.length===0" class="list-group-item text-center">
                            There is no job 🥺
                        </li>
                        <Listcreate  v-for= "list in lists" :key="list.id" :list="list" @del="del"></Listcreate>

                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Form from './components/Form.vue'
import Listcreate from './components/Listcreate.vue'
import Title from './components/Title.vue'
  export default {
  components: { Listcreate, Form, Title },
    name :'App',
    data() {
      return {
             currentId : 0,
            
            lists : [],
            
      }
    },
    computed: {
            DoneTotal(){
                return this.lists.filter(el=> el.isDone ===true).length
            }
        },
        methods : {
            create(x){
                this.currentId++,
               this.lists.push({
                   id : this.currentId,
                   message: x,
                   isEdit  : false,
                   isDone : false,
                   isDelete : false
               }) 
                this.newMessage= ""
            },
            del(x){
           setTimeout(() => {
            this.lists = this.lists.filter(el=> el.id !==x)  
           }, 450);
            }   
        }
  }
</script>

<style >
  
    .done{
        text-decoration: line-through !important;
        animation: 0.5s shakeX;
    }
    .created{
        animation : 0.5s fadeInDown;
    }
    .deleted{
        animation : 0.5s zoomOut;
    }
</style>